import React, { memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import useDndStore from '../stores/dndStore';
import { Box, Flex, Icon, useColorMode } from '@chakra-ui/react';
import { MotionBox } from './UiElements';
import { useDroppable } from '@dnd-kit/core';
import GroupDroppable from './GroupDroppableWrapper';

const DropTabNewGroup = () => {
    const isDragging = useDndStore((state) => state.globalIsDragging);
    const isOverContainer = useDndStore(
        (state) => state.overContainerZu === 'ContainerPlaceholder'
    );

    const { setNodeRef } = useDroppable({
        id: 'ContainerPlaceholder',
        data: { type: 'dragGroup' }
    });

    const container = {
        show: {
            scale: 1,
            opacity: isOverContainer ? 1 : 0.45,
            //originY: 0.5,
            transition: {
                scale: { type: 'spring', damping: 20, stiffness: 180 }
            }
        },
        exit: {
            scale: 0,
            opacity: 0,
            //originY: 0,
            transition: { duration: 0 }
        }
    };

    const dropZone = {
        rest: { scale: 1 },
        hover: { scale: 0.98 }
        /* isOverContainer
            ? { scale: 0.98, transition: { ease: 'easeOut', duration: 0.05 } }
            : {} // Adjust scale based on isOverContainer */
    };

    const icon = {
        rest: { scale: 0.75, y: -50, opacity: 0, originY: 1 },
        hover: isOverContainer
            ? {
                  scale: 1.75,
                  y: 0,
                  opacity: 1,
                  originY: 0,
                  transition: { type: 'spring', duration: 0.15 }
              }
            : {} // Adjust icon properties based on isOverContainer
    };

    return (
        <GroupDroppable id={'ContainerPlaceholder'}>
            <Box
                ref={setNodeRef}
                position="relative"
                width={isDragging ? '367px' : '0px'} //"21.850vw"
                //minWidth="240px"
                minHeight="100%"
                maxW="367px"
                display="flex"
                textAlign="left"
                borderRadius="16px"
                zIndex="1"
                marginRight={isDragging ? '24px' : '16px'}
            >
                <AnimatePresence>
                    {isDragging && (
                        <MotionBox
                            key={isDragging ? 'dragging' : 'notDragging'}
                            zIndex="3"
                            position="absolute"
                            variants={container}
                            initial={{
                                scale: 0.9,
                                opacity: 0
                            }}
                            animate="show"
                            exit="exit"
                            whileHover="hover"
                            width="21.850vw"
                            minWidth="280px"
                            maxW="367px"
                            height="100%"
                            display="flex"
                            cursor="pointer"
                            textAlign="left"
                            borderRadius="16px"
                            border={
                                isOverContainer
                                    ? '2px solid #41E18B'
                                    : '2px solid #41E18B'
                            } // Highlight border if over container
                            bg={
                                /* isOverContainer
                                    ? 'rgb(65, 225, 139, 0.1)'
                                    :  */ 'rgb(65, 225, 139, 0.1)'
                            }
                        >
                            <MotionBox
                                //_groupHover={{scale: }}
                                //variants={dropZone}
                                animate={{ scale: isOverContainer ? 0.98 : 1 }}
                                initial="rest"
                                display="Flex"
                                flexDir="column"
                                alignItems="center"
                                w="100%"
                                h="100%"
                            >
                                <Box
                                    display="flex"
                                    p="18px"
                                    w="100%"
                                    opacity="0.4"
                                >
                                    <Box
                                        background="#41E18B"
                                        mt="0.5rem"
                                        fontSize="2.95rem"
                                        ml="4px"
                                        px="12px"
                                        height="54px"
                                        w="54px"
                                        rounded="8px"
                                    ></Box>
                                    <Flex
                                        ml="0.8rem"
                                        mr="0.6rem"
                                        mt="0.65rem"
                                        flexDir="column"
                                        textAlign="left"
                                    >
                                        <Box
                                            bg="#41E18B"
                                            rounded="6px"
                                            height="24px"
                                            w="136px"
                                        />
                                        <Box
                                            bg="#41E18B"
                                            rounded="4px"
                                            height="18px"
                                            mt="6px"
                                            w="64px"
                                        />
                                    </Flex>
                                </Box>
                                <MotionBox
                                    variants={icon}
                                    initial="rest"
                                    animate={isOverContainer ? 'hover' : 'rest'}
                                    m="auto"
                                    display="flex"
                                    alignItems="center"
                                    pb="20vh"
                                >
                                    <Icon
                                        m="auto"
                                        as={ArrowCircleDownGreen}
                                        fontSize="54px"
                                        color="#41E18B"
                                    />
                                </MotionBox>
                            </MotionBox>
                        </MotionBox>
                    )}
                </AnimatePresence>
            </Box>
        </GroupDroppable>
    );
};

export default DropTabNewGroup;

export const ArrowCircleDownGreen = ({ size = '54px' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="#41E18B"
            style={{ width: size, height: size }}
        >
            <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z"
                clipRule="evenodd"
            />
        </svg>
    );
};
